export type AppCompatibility = "connect" | "services" | "both";

const SERVICES_ONLY_APPS = new Set([
  "reservewithgoogle",
  "reserve-with-google",
]);

const CONNECT_ONLY_APPS = new Set([
  "routing-forms",
  "autocheckin",
  "wipemycalother",
]);

export function getAppCompatibility(slug: string): AppCompatibility {
  if (SERVICES_ONLY_APPS.has(slug)) return "services";
  if (CONNECT_ONLY_APPS.has(slug)) return "connect";
  return "both";
}

export function getCompatibilityLabel(compat: AppCompatibility): string {
  switch (compat) {
    case "connect":
      return "Schedly Connect";
    case "services":
      return "Schedly Services";
    case "both":
      return "Connect & Services";
  }
}

export function getCompatibilityColor(compat: AppCompatibility): {
  bg: string;
  text: string;
  darkBg: string;
  darkText: string;
} {
  switch (compat) {
    case "connect":
      return {
        bg: "bg-blue-50",
        text: "text-blue-700",
        darkBg: "dark:bg-blue-900/30",
        darkText: "dark:text-blue-300",
      };
    case "services":
      return {
        bg: "bg-purple-50",
        text: "text-purple-700",
        darkBg: "dark:bg-purple-900/30",
        darkText: "dark:text-purple-300",
      };
    case "both":
      return {
        bg: "bg-emerald-50",
        text: "text-emerald-700",
        darkBg: "dark:bg-emerald-900/30",
        darkText: "dark:text-emerald-300",
      };
  }
}
